import React, { useEffect } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import PrivateLayout from './PrivateLayout';
import PublicLayout from './PublicLayout';

function isAuthenticated(token) {
  if (!token) return false;

  const { auth } = token;
  const decoded = jwtDecode(auth);

  return Date.now() < decoded.exp * 1000;
}

const MainLayout = () => {
  const history = useHistory();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));

    if (!isAuthenticated(user)) {
      localStorage.clear();
      // history.push('/login');
    }
  }, [history]);

  const userToken = JSON.parse(localStorage.getItem('user'));
  const isLoggedIn = isAuthenticated(userToken);

  return (
    <>
      {isLoggedIn ? <PrivateLayout /> : <PublicLayout />}
    </>
  );
};

export default withRouter(MainLayout);
